"use strict";function infoLog(){return console.log(...arguments)}export default infoLog;